import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64, IMAGEM_LOGO_CENTRUS_CONTRACHEQUE_BASE64 } from '../../../../../../app.constants';
import { ContrachequeListDTO } from '../../../../dominios/DTO/contracheque-list.DTO';
import { InformacaoContrachequeDTO } from '../../../../dominios/DTO/informacoes-contracheque.DTO';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';

@Injectable()
export class ContrachqueAposentadoPdf {


    constructor(
        private _decimalPipe: DecimalPipe,
        private _cpf: CpfPipe
    ) { }

    public aposentado(mesAno: string, pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel,
        informacaoContrachequeDTO: InformacaoContrachequeDTO, contrachequeList: Array<ContrachequeListDTO>) {

        const doc = new jsPDF('p', 'mm', 'a4');

        doc.addImage(IMAGEM_LOGO_CENTRUS_CONTRACHEQUE_BASE64, 'PNG', 90, 20, 30, 20);
        doc.setFontSize(11);
        doc.setFont('Source Sans Pro');
        doc.setFontStyle('bold');
        doc.text(`FOLHA INDIVIDUAL DE PAGAMENTO`, 70, 50)
        doc.autoTable({
            startY: 60
        })

        doc.autoTable({
            theme: 'plain',
            headStyles: {
                fillColor: [226, 235, 248],
                fontSize: 8,
            },
            styles: {
                fillColor: [226, 235, 248],
                fontSize: 8,
            },
            head: [['CPF', 'Nome', 'Local', 'Ano Calendário']],
            body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome, informacaoContrachequeDTO.local, mesAno]],
        });



        doc.autoTable({
            theme: 'plain',
            headStyles: {
                fillColor: [226, 235, 248],
                fontSize: 9,
            },
            head: this._headRowscontrachequeList(),
            styles: { fontSize: 8, textColor: [0, 0, 0] },
            body: this._bodyRowsContrachequeList(contrachequeList),

            willDrawCell: function (data) {
                if (data.row.section === 'body' && data.column.dataKey === 'descricao') {
                    if (data.cell.raw === 'DESCONTOS') {
                        doc.setFontStyle('bold')
                        doc.setFontSize(8)
                    }
                }
                if (data.row.section === 'body' && data.column.dataKey === 'descricao') {
                    if (data.cell.raw === 'OUTROS') {
                        doc.setFontStyle('bold')
                        doc.setFontSize(8)
                    }
                }
            },
            didParseCell: function (data) {

                if (data.row.index === 0 &&
                    data.row.section === 'body' &&
                    data.column.dataKey === 'descricao') {
                    data.cell.styles.fontStyle = 'bold'
                    data.cell.styles.fontSize = 8
                }

                if (data.row.section === 'body' &&
                    data.column.dataKey === 'valor') {
                    data.cell.styles.halign = 'right'
                }
                if (data.row.section === 'body' &&
                    data.column.dataKey === 'saldoBC') {
                    data.cell.styles.halign = 'center'
                }
                if (data.row.section === 'body' &&
                    data.column.dataKey === 'competencia') {
                    data.cell.styles.halign = 'center'
                }
                if (data.row.section === 'body' &&
                    data.column.dataKey === 'parcelas') {
                    data.cell.styles.halign = 'right'
                }
                if (data.row.section === 'head' &&
                    data.column.dataKey === 'parcelas') {
                    data.cell.styles.halign = 'right'
                }
                if (data.row.section === 'head' &&
                    data.column.dataKey === 'valor') {
                    data.cell.styles.halign = 'right'
                }
                if (data.row.section === 'head' &&
                    data.column.dataKey === 'competencia') {
                    data.cell.styles.halign = 'center'
                }
            },
            footStyles: {
                fillColor: [226, 235, 248],
                fontSize: 8,
                0: { halign: 'left' },
                1: { halign: 'center' },
                2: { halign: 'right' }
            },
            foot: [[
                `Valor Bruto\n${informacaoContrachequeDTO.valorBruto}`,
                `                   `,
                `             `,
                `Descontos\n${informacaoContrachequeDTO.desconto}`,
                `                   `,
                `Valor Líquido\n${(informacaoContrachequeDTO.valorLiquido)}`
            ]],
        });


        doc.autoTable({ body: [] })

        doc.setFontSize(10);
        doc.setFontStyle("bold");
        doc.setFont('Source Sans Pro');
        doc.text(informacaoContrachequeDTO.msgTitle, 15,  doc.previousAutoTable.finalY + -1)
        


        doc.autoTable({ body: [] })

        


        // doc.autoTable({ body: [] })

        doc.autoTable({
            theme: 'plain',
            headStyles: {
                fillColor: [226, 235, 248],
                fontSize: 8,
            },
            head: this._headRowsDetalhesSuperior(),
            didParseCell: function (data) {
                if (data.row.index === 0 &&
                    data.column.index === 6) {
                    data.cell.styles.halign = 'left'
                }
                if (data.row.index === 1 &&
                    data.column.index === 6) {
                    data.cell.styles.halign = 'right'
                }
            },
            columnStyles: { 5: { halign: 'right' } },
            body: this._bodyRowsDetalhesSuperior(informacaoContrachequeDTO),
            styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'center' }
        });

        doc.autoTable({
            theme: 'plain',
            headStyles: {
                fillColor: [226, 235, 248],
                fontSize: 8
            },
            head: this._headRowsDetalhesInferior(),
            body: this._bodyRowsDetalhesInferior(informacaoContrachequeDTO),
            styles: { fontSize: 8, textColor: [0, 0, 0], halign: 'center' }
        });

        doc.setProperties({
            title: 'Contracheque',
            subject: `Contracheque gerado em ${new Date('dd/mm/yyy')} `,
            author: 'centrus',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Fundação Banco central de previcência provida - centrus'
        });




        (window.innerWidth > 640)
            ? (window.open(URL.createObjectURL(doc.output('blob'))))
            : this.handleFile(doc.output('blob'), 'contracheque.pdf');
    }

    handleFile(res: any, fileName: string) {
        const file = new Blob([res], {
            type: res.type
        });

        // IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
            return;
        }



        const blob = window.URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = blob;
        link.download = fileName;

        // link.click();
        link.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        }));

        setTimeout(() => { // firefox
            window.URL.revokeObjectURL(blob);
            link.remove();
        }, 100);
    }

    private _bodyRowsContrachequeList(contrachequeList: Array<ContrachequeListDTO>) {
        const body = []

        contrachequeList.map(item => {
            body.push({
                verba: item.verba,
                descricao: item.descricao,
                parcelas: item.parcelas,
                saldoBC: item.saldoBC,
                competencia: item.competencia,
                valor: item.valor
            })
        })

        return body;
    }

    private _headRowscontrachequeList() {
        return [{
            verba: 'Verba',
            descricao: 'Descrição',
            parcelas: 'Parcelas',
            saldoBC: 'Saldo/Base de Cáculo',
            competencia: 'Competência',
            valor: 'Valor'
        },
        ]
    }


    private _bodyRowsDetalhesSuperior(informacaoContrachequeDTO: InformacaoContrachequeDTO) {
        const body = []

        body.push({
            banco: informacaoContrachequeDTO.banco,
            agencia: informacaoContrachequeDTO.agencia,
            conta: informacaoContrachequeDTO.contaCorrent,
            depSal: informacaoContrachequeDTO.depSalFam,
            depIR: informacaoContrachequeDTO.depIR,
            isento: informacaoContrachequeDTO.irIsencaoIr
        })

        return body;
    }

    private _headRowsDetalhesSuperior() {

        let header = [];
        header = [{
            banco: 'Banco',
            agencia: 'Agência',
            conta: 'Conta-corrente',
            depSal: 'Dep. Sal. Fam.',
            depIR: 'Dep. I. R.',
            isento: 'Isento'
        },
        ]

        return header;
    }


    private _bodyRowsDetalhesInferior(informacaoContrachequeDTO: InformacaoContrachequeDTO) {
        const body = []

        body.push({
            margem30: informacaoContrachequeDTO.margem30,
            margem70: informacaoContrachequeDTO.margem70,
            centrus: informacaoContrachequeDTO.nrNossoNumero,
            inss: informacaoContrachequeDTO.nrBenefInss
        })
        return body;
    }

    private _headRowsDetalhesInferior() {

        let header = [];
        header = [{
            margem30: 'Margem de 35%',
            margem70: 'Margem de 70%',
            centrus: 'Nr Benef. Centrus',
            inss: 'Nr Benef. INSS'
        },
        ]

        return header;
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-aposentados-pdf.ts